import { render, staticRenderFns } from "./SingpassAgent.vue?vue&type=template&id=4060b773&"
import script from "./SingpassAgent.vue?vue&type=script&lang=js&"
export * from "./SingpassAgent.vue?vue&type=script&lang=js&"
import style0 from "./SingpassAgent.vue?vue&type=style&index=0&id=4060b773&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports